import * as React from "react";
import SelectComponent from "../../../ui/select/SelectComponent";
import {connect} from "react-redux";
import {RootState} from "../../../../store/reducer/root/RootState";
import Utility from "../../../../model/utility/Utility";

class SelectUtility extends SelectComponent<Utility> {
	onInputChange(value: string) {
		this.props.onInputChange(value);
	}

	matchFilter(element: Utility, filter: string): boolean {
		return element.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Utility): string {
		return element.id;
	}

	elementToString(element: Utility) {
		return element.name;
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.utility.utilities
	}
}

export default connect(mapStateToProps)(SelectUtility)
